import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  mergeWebsocketDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformComment } from './comments.transformers';
import { CommentsCollection } from './comments.types';

export function commentsReducer(
  state: CollectionStateSlice<CommentsCollection> = {},
  action: CollectionActions<CommentsCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'comments') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<CommentsCollection>(
          state,
          transformIntoDocuments(result.comments, transformComment),
          order,
          ref,
        );
      }
      return state;

    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'comments') {
        const { result: rawMessage, ref } = action.payload;
        return mergeWebsocketDocuments<CommentsCollection>(
          state,
          transformIntoDocuments([rawMessage], transformComment),
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
